module.exports = __webpack_public_path__ + "media/images/tooltip-trigger-arrow-0ca60686a6e5bcd0138a908b5f6b8c17.svg";